import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, Input } from '@angular/core';
import { CSSModifier, CSSComponent } from '@odx/angular/internal';
import { injectElement } from '@odx/angular/utils';

const LogoSize = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};

const LogoVariant = {
    DEFAULT: 'default',
    INVERSE: 'inverse',
};

/**
 * A directive that handles the presentation of a logo with configurable size and variant.
 */
let LogoDirective = class LogoDirective {
    constructor() {
        this.element = injectElement();
        /**
         * The size of the logo.
         *
         * @type {LogoSize}
         * @default LogoSize.SMALL
         */
        this.size = LogoSize.SMALL;
        /**
         * The variant of the logo.
         *
         * @type {LogoVariant}
         * @default LogoVariant.DEFAULT
         */
        this.variant = LogoVariant.DEFAULT;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LogoDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: LogoDirective, isStandalone: true, selector: "odx-logo", inputs: { size: "size", variant: "variant" }, host: { attributes: { "translate": "no", "role": "img" }, properties: { "class.notranslate": "true", "attr.aria-label": "\"Dr\u00E4ger logo\"", "attr.aria-roledescription": "\"logo\"" } }, ngImport: i0 }); }
};
__decorate([
    CSSModifier(),
    __metadata("design:type", String)
], LogoDirective.prototype, "size", void 0);
__decorate([
    CSSModifier(),
    __metadata("design:type", String)
], LogoDirective.prototype, "variant", void 0);
LogoDirective = __decorate([
    CSSComponent('logo')
], LogoDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LogoDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'odx-logo',
                    standalone: true,
                    host: {
                        '[class.notranslate]': 'true',
                        '[attr.aria-label]': '"Dräger logo"',
                        '[attr.aria-roledescription]': '"logo"',
                        translate: 'no',
                        role: 'img',
                    },
                }]
        }], propDecorators: { size: [{
                type: Input
            }], variant: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { LogoDirective, LogoSize, LogoVariant };
